<div class="ask-the-author">
  <div class="authors-list">
    <app-ask-the-author-list [authors]="authors"></app-ask-the-author-list>
  </div>
  <div class="author-button">
    <app-ask-the-author-button [authors]="authors" [isDisabled]="!isAskAuthorEnabled" (clickAskAuthor)="onAsk()"></app-ask-the-author-button>
  </div>
</div>
